import axios from "axios";
import { Notification, MessageBox, Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
var service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 60000
});
var path;
// request拦截器
service.interceptors.request.use(function (config) {
  // 是否需要设置 token
  // console.log(config);
  path = config.url;
  var isToken = (config.headers || {}).isToken === false;
  if (getToken() && !isToken) {
    config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config;
}, function (error) {
  console.log(error);
  Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(function (res) {
  // 未设置状态码则默认成功状态
  var code = res.data.code || 0;
  // 获取错误信息
  var message = errorCode[code] || res.data.msg || errorCode["default"];
  if (code === -401) {
    MessageBox.alert("登录状态已过期，请重新登录", "系统提示", {
      confirmButtonText: "重新登录",
      cancelButtonText: "取消",
      type: "warning"
    }).then(function () {
      store.dispatch("LogOut").then(function () {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    });
  } else if (code === 500) {
    Message({
      message: message,
      type: "error"
    });
    return Promise.reject(new Error(message));
  } else if (code !== 0) {
    Notification.error({
      title: message
    });
    return Promise.reject("error");
  } else {
    if (path == "/system/team/preview-auth") {
      return res;
    }
    return res.data;
  }
}, function (error) {
  console.log("err" + error);
  Message({
    message: error.message,
    type: "error",
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;